import {useSyncExternalStore} from 'react';

const subscribe = () => () => {};

/**
 * Returns `false` on the server and on the first client render, then `true` on every render after that.
 *
 * @remarks
 * Prefer this over a `useState` + `useEffect` "mounted" flag, which causes an extra render pass.
 */
export const useIsClient = (): boolean =>
    useSyncExternalStore(
        subscribe,
        () => true, // getSnapshot (client, post-hydration)
        () => false, // getServerSnapshot (server + first client render)
    );
